export enum State {
  INIT = 'init',

  ABORT_APPLICATION = 'abort-application',

  ELIGIBILITY = 'eligibility',
  PERSONAL_INFO = 'personal-info',
  COMPANY_COMPLIANCE = 'company-compliance',

  BUSINESS_INFO_FORM = 'business-info-form',
  BUSINESS_INFO_REFUSED = 'business-info-refused',
  BUSINESS_INFO_COMPLETE = 'business-info-complete',

  VERIFICATION = 'verification',

  USER_AGREEMENT = 'user-agreement',

  PLAN_CHOICE = 'plan-choice',

  SUBMIT_APPLICATION = 'submit-application',

  NEXT_STEPS = 'next-steps',

  DONE = 'done',
  ABORT = 'abort',
}
